import { handleActions } from 'redux-actions';
import {
  ListRoleDataProps,
  RoleObjects,
  RolePermissions,
  RoleProps,
  RolesState,
} from './interfaces';
import Types from './types';

const initialState: RolesState = {
  isLoading: false,
  roleInfo: {} as RoleProps,
  roleList: {} as ListRoleDataProps,
  objects: {} as RoleObjects,
  permissions: {} as RolePermissions,
};

export default handleActions(
  {
    [Types.REGISTER_ROLE_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REGISTER_ROLE_FULFILLED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REGISTER_ROLE_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_ROLE_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_ROLE_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      roleInfo: payload,
      isLoading: false,
    }),
    [Types.EDIT_ROLE_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_ROLES_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_ROLES_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      roleList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_ROLES_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.RESET_GROUPS_SEARCH]: (state: RolesState) => ({
      ...state,
      isLoading: false,
      roleList: [],
    }),

    [Types.REMOVE_ROLES_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_ROLES_FULFILLED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_ROLES_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ROLE_INFO_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ROLE_INFO_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      roleInfo: payload,
      isLoading: false,
    }),
    [Types.GET_ROLE_INFO_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_OBJECTS_REQUEST]: (state: RolesState) => ({
      ...state,
      objects: initialState.objects,
      isLoading: true,
    }),
    [Types.GET_ALL_OBJECTS_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      objects: payload,
      isLoading: false,
    }),

    [Types.GET_OBJECTS_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_OBJECTS_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      objects: {
        ...state.objects,
        ...payload,
      },
      isLoading: false,
    }),
    [Types.GET_OBJECTS_REJECTED]: (
      state: RolesState,
      { payload: { entity } }
    ) => ({
      ...state,
      objects: {
        ...state.objects,
        [entity]: {
          ...state.objects[entity],
          loading: false,
        },
      },
    }),

    [Types.GET_OBJECTS_AVAILABLE_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_OBJECTS_AVAILABLE_FULFILLED]: (
      state: RolesState,
      { payload }
    ) => ({
      ...state,
      objects: {
        ...state.objects,
        ...payload,
      },
      isLoading: false,
    }),
    [Types.GET_OBJECTS_AVAILABLE_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REGISTER_OBJECTS_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REGISTER_OBJECTS_FULFILLED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REGISTER_OBJECTS_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_OBJECTS_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_OBJECTS_FULFILLED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_OBJECTS_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_PERMISSIONS_REQUEST]: (
      state: RolesState,
      { payload: { entity } }
    ) => ({
      ...state,
      permissions: {
        ...state.permissions,
        [entity]: {
          ...state.permissions[entity],
          loading: true,
        },
      },
    }),
    [Types.GET_PERMISSIONS_FULFILLED]: (state: RolesState, { payload }) => ({
      ...state,
      permissions: {
        ...state.permissions,
        ...payload,
      },
    }),
    [Types.GET_PERMISSIONS_REJECTED]: (
      state: RolesState,
      { payload: { entity } }
    ) => ({
      ...state,
      permissions: {
        ...state.permissions,
        [entity]: {
          ...state.permissions[entity],
          loading: false,
        },
      },
    }),

    [Types.REGISTER_PERMISSIONS_REQUEST]: (
      state: RolesState,
      { payload: { entity } }
    ) => ({
      ...state,
      permissions: {
        ...state.permissions,
        [entity]: {
          ...state.permissions[entity],
          loading: true,
        },
      },
    }),
    [Types.REGISTER_PERMISSIONS_FULFILLED]: (
      state: RolesState,
      { payload }
    ) => ({
      ...state,
      permissions: {
        ...state.permissions,
        ...payload,
      },
    }),
    [Types.REGISTER_PERMISSIONS_REJECTED]: (
      state: RolesState,
      { payload: { entity } }
    ) => ({
      ...state,
      permissions: {
        ...state.permissions,
        [entity]: {
          ...state.permissions[entity],
          loading: false,
        },
      },
    }),

    [Types.CLONE_ROLE_REQUEST]: (state: RolesState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.CLONE_ROLE_FULFILLED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.CLONE_ROLE_REJECTED]: (state: RolesState) => ({
      ...state,
      isLoading: false,
    }),
  },
  initialState
);
